module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./client/app/make/make.component.scss
// module id = ./client/app/make/make.component.scss
// module chunks = main